var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDices16Px = function SvgIconDices16Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M9.34 8.493A1.83 1.83 0 0 0 7.508 6.66H2.841a1.833 1.833 0 0 0-1.834 1.833v4.667a1.835 1.835 0 0 0 1.834 1.833h4.666a1.834 1.834 0 0 0 1.834-1.833zm-1.833 4a.667.667 0 1 0-1.334 0 .667.667 0 0 0 1.334 0m-4-.667a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334m1.667-1.666a.667.667 0 1 0 0 1.333.667.667 0 0 0 0-1.333m1.667-1.667a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334m-2.667.667a.667.667 0 1 0-1.334 0 .667.667 0 0 0 1.334 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M5.685 5.993h1.822a2.5 2.5 0 0 1 2.5 2.5v1.728c.55.186.928.307.952.316a1.834 1.834 0 0 0 2.345-1.104l1.58-4.391a1.83 1.83 0 0 0-1.104-2.346l-4.39-1.58A1.83 1.83 0 0 0 7.042 2.22zm6.12 2.192a.667.667 0 1 0-1.256-.452.667.667 0 0 0 1.256.452m-1.406-2.986a.666.666 0 1 0-.45 1.254.666.666 0 0 0 .45-1.254m-.602-1.28a.667.667 0 1 0-1.256-.45.667.667 0 0 0 1.256.45",
    clipRule: "evenodd"
  })));
};
export default SvgIconDices16Px;